

export function gateways (param ,cb, errorCb) {
  window.axios({
    method: 'get',
    url: `gateway`,
    baseURL: param.url
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function devices (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: `device`,
    baseURL: param.url
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function positions (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: `positions?trackingId=${param.trackingId}`,
    baseURL: param.url
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function positions_history (param, cb, errorCb) {
  window.axios({
    method: 'get',
    url: `positions/history?trackingId=${param.trackingId}&startDate=${param.startDate}&endDate=${param.endDate}`,
    baseURL: param.url
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}

export function bulk_positions (param, cb, errorCb) {
  window.axios({
    method: 'post',
    url: `positions`,
    data: param.data,
    baseURL: param.url
  }).then(response => {
    cb(response)
  }).catch(error => {
    errorCb(error)
  })
}